import config from '../../config';

const B2B_ROOT = 'https://business.localsearch.com.au';

const B2B_LINKS = {
  b2bRoot: B2B_ROOT,
  b2bWebDesignDevelopment: `${B2B_ROOT}/affordable-websites`,
  b2bPerformanceBoost: `${B2B_ROOT}/performance-boost`,
  b2bSEOServices: `${B2B_ROOT}/seo-services`,
  b2bSocialMediaMarketing: `${B2B_ROOT}/social-media-marketing`,
  b2bPortfolio: `${B2B_ROOT}/portfolio`,
  b2bWebsitePortfolio: `${B2B_ROOT}/website-portfolio`,
  b2bDigitalMarketing: `${B2B_ROOT}/our-services`,
  b2bWebHosting: `${B2B_ROOT}/web-hosting`,
  b2bLSAdvertising: `${B2B_ROOT}/add-a-business-to-localsearch-online`,
  b2bGMB: `${B2B_ROOT}/google-business-profile-optimisation`,
  b2bCaseStudies: `${B2B_ROOT}/case-study`,
  b2bBlog: `${B2B_ROOT}/blog`,
  b2bFAQs: `${B2B_ROOT}/faq`,
  b2bSEM: `${B2B_ROOT}/search-engine-marketing`,
  b2bSiteMap: `${config.urlRoot}/sitemap`,
  b2bFind: `${config.urlRoot}/find`,
};

const BPM_ROOT = 'https://business-profile.localsearch.com.au';

const BPM_LINKS = {
  bpmRoot: BPM_ROOT,
  addBusiness: `${BPM_ROOT}/create-profile`,
};

const LINKS = {
  nucleus: 'https://nucleus.localsearch.com.au',
  lifestyleBlog: 'https://blog.localsearch.com.au/',
  costGuides: 'https://www.localsearch.com.au/guides/',
  appDownload: 'https://urlgeni.us/qnr9',
  knowledgeBase: 'https://knowledge.localsearch.com.au',
  ...B2B_LINKS,
  ...BPM_LINKS,
};

export default LINKS;
